import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { UpdateSiteInput } from "../../../__generated__/globalTypes";
import { UPDATE_SITE } from "../sites.queries";

import { parseParams } from "../../../helpers/clean-object";
import {
  UpdateSiteMutation,
  UpdateSiteMutationVariables,
} from "../../../__generated__/UpdateSiteMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
  onError: (msg: string) => any;
}

export const useUpdateSite = ({ id, onCompleted, onError }: IProps) => {
  const form = useForm<UpdateSiteInput>({
    mode: "all",
  });

  const [mutate, { loading }] = useMutation<
    UpdateSiteMutation,
    UpdateSiteMutationVariables
  >(UPDATE_SITE);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateSite?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateSite?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
      onError(error.message);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
